
import { isEmpty } from '@zero-org/utils'
import { Component, Prop, Vue } from 'vue-property-decorator'
import Bus from '@/utils/bus'

@Component
export default class Satisfaction extends Vue {
  readonly maxLength = 100

  list = [{
    label: '非常满意',
    value: '401'
  }, {
    label: '满意',
    value: '402'
  }, {
    label: '基本满意',
    value: '403'
  }, {
    label: '不满意',
    value: '404'
  }]

  listB = [{
    label: '政策不满意',
    value: '40401'
  }, {
    label: '服务不满意',
    value: '40402'
  }, {
    label: '其他',
    value: '40403'
  }]

  visible = false
  view: any = {
    levelA: '401',
    levelB: '40403',
    reason: ''
  }

  mounted() {
    Bus.$on('onSatisfaction', (obj: any) => {
      this.visible = true
    })
  }

  beforeDestroy() {
    Bus.$off('onSatisfaction')
  }

  show() {
    this.visible = true
  }

  onChange(val: string) {
    if (val !== '404') {
      this.view.levelB = '40403'
      this.view.reason = ''
    }
  }
  getJson(obj: any) {
    if (obj.levelA !== '404') {
      const item = this.list.find(item => item.value === obj.levelA)
      return {
        SatisfactionType: item?.value,
        SatisfactionMsg: item?.label
      }
    }

    if (obj.levelB !== '40403') {
      const item = this.listB.find(item => item.value === obj.levelB)
      return {
        SatisfactionType: item?.value,
        SatisfactionMsg: item?.label
      }
    }

    return {
      SatisfactionType: '40403',
      SatisfactionMsg: obj.reason.trim()
    }
  }

  onOk() {
    if (
      this.view.levelA === '404' &&
      this.view.levelB === '40403' &&
      isEmpty(this.view.reason)
    ) {
      this.$message.error('请输入不满意原因')
      return
    }

    const json = this.getJson(this.view)
    this.$emit('submit', json)
    this.$message.success('提交成功，感谢您的评价！')
    this.visible = false
  }

  onCancel() {
    this.visible = false
  }

  afterClose() {
    this.view = {
      levelA: '401',
      levelB: '40403',
      reason: ''
    }
  }
}
